import { API, COMMONFILE_UPLOAD } from "./static.data.pnp";



export const urlApi = {

    // GENERAL
    imageUpload: API + "/file/image-upload",
    fileUpload: COMMONFILE_UPLOAD + "/api/v1/website-file-upload",

    getTemplatesListNP: API + "/prompt-instruction/whatsapp-templates/",

    whatsAppTemplateImageUploadApi: API + "/file/image-upload",
    whatsAppTemplateVideoUploadApi: API + "/file/video-upload",

    //AUTH
    login: API + "/auth/login",

    // ADMIN
    getMyProfile: API + "/admin/my-profile",
    allAdmin: API + "/admin/list",
    addAdmin: API + "/admin/add-admin",
    updateAdminStatus: API + "/admin/status-update/",

    //DASHBOARD
    userCount: API + "/dashboard/users-count",
    top5Users: API + "/dashboard/top-users/",
    top5Table: API + "/dashboard/top-links/",
    countData: API + "/dashboard/link-count",
    userRegistrationGraph: API + "/dashboard/user-count-graph",
    linkClickAndCreateGraph: API + "/dashboard/link-analysis-graph",

    //USER 
    getAllUsers: API + "/user/list",
    useDetailsById: API + "/user/details/",
    issueListOfUser: API + "/user/submitted-issue-list/",
    updateIssueStatusOfUser: API + "/user/update-submitted-issue/",
    rewardListOfUser: API + "/user/reward-list/",
    updateUserStatus: API + "/user/status-update/",
    userAnalyticsCard: API + "/user/engagement-cards/",
    userClickDeviceData: API + "/user/device-data/",
    userClickLocationData: API + "/user/location-data/",
    userClickReferredData: API + "/user/referrer-data/",
    creditRewardToUser: API + "/user/credit-balance",
    deductRewardFromUser: API + "/user/debit-balance",
    updateUserDetails: API + "/user/update-profile",
    userBankList: API + "/user/bank-list/",
    updateBankStatusOfUser: API + "/user/update-bank-status/",
    addInstructionToUser: API + "/prompt-instruction/add",
    getInstructionOfUser: API + "/prompt-instruction/list/",
    deleteInstructionOfUser: API + "/prompt-instruction/delete/",

    getChatPlanList: API + "/moina-plan/list",
    generatePaymentLink: API + "/moina-plan/generate-payment-link",
    assignChatPlanToUser: API + "/moina-plan/assign-plan",

    // ORGANIZATION
    getOrgListOfUser: API + "/organization/list/",
    ingestSite: API + "/chat/ingest-website",

    //LINKS
    getLinksList: API + "/link/list",

    // QR
    getQRList: API + "/qr/list",

    //PAGES
    getPagesList: API + "/page/list",
    getSubLinksOfPage: API + "/page/sub-links/",

    // BUSINESS CARDS
    getBusinessCardsList: API + "/business-card/list",
    getSubLinkOfBusinessCard: API + "/business-card/sub-links/",

    //TRANSACTION
    getWithdrawRequests: API + "/transaction/withdraw-list",
    updateWithdrawStatus: API + "/transaction/update-withdraw-request/",
    withdrawRequestStatsCard: API + "/transaction/withdraw-cards",

    //FEEDBACK&REPORT
    getFeedbackList: API + "/submitted-issue/list",
    updateFeedbackStatus: API + "/submitted-issue/update-issue/",

    //TEMPLATES
    getTemplatesList: API + "/template/list",
    updateTemplateStatus: API + "/template/update-status/",
    addTemplate: API + "/template/add",

    // LINK ANALYTICS
    getAnalysisGraphData: API + "/link/analysis-graph/",
    getAnalysisLocationTableData: API + "/link/location-wise-data/",
    browserDonutChartData: API + "/link/browser-wise-data/",
    operatingSystemDonutChartData: API + "/link/os-wise-data/",
    updateLinkStatus: API + "/link/status-update/",

    //SETTINGS
    getSettings: API + "/setting/list",
    getSettingDetails: API + "/setting/details/",
    updateRewardRate: API + "/setting/update/reward-rate",
    updateMinWithdrawValue: API + "/setting/update/min-withdraw-value",
    addShortLinkDomain: API + "/setting/add/domain",
    updateShortLinkDomainStatus: API + "/setting/update/domain-status",
    updateRewardShowStatus: API + "/setting/update/reward-show-status",

    // ISSUE LIST
    getIssueList: API + "/issue/list",
    updateIssueStatus: API + "/issue/status-update/",
    addIssue: API + "/issue/add",
    updateIssue: API + "/issue/update",

    // PLAN REQUEST
    getPlanRequestsList: API + "/plan/requests",
    updatePlanRequestStatus: API + "/plan/update-status/",

    // LIVE CHAT
    getLiveChatPurchasedList: API + "/chat/purchased-plans",

    addWhatsAppTemplate: API + "/prompt-instruction/create-custom-template",
}

